module.exports = __webpack_public_path__ + "static/img/QLD-2.0d00d72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QLD-2.jpg
// module id = Kd78
// module chunks = 0